// متن «تا …» شیت قفلِ دورهٔ پلکان جریمه — عین nelson-front (features/book-list/ovLockUntil.ts)، همیشه وقت تهران.
// امروز/فردا با ساعت؛ دورتر فقط تاریخ شمسی با سال (قفل یک‌ساله بی‌سال مبهم است).
const TZ = 'Asia/Tehran';

const dayKey = (d: Date) =>
  new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);

export function formatOvLockUntil(iso: string, now: Date = new Date()): string | null {
  const until = new Date(iso);
  if (Number.isNaN(until.getTime())) return null;
  const time = new Intl.DateTimeFormat('fa-IR', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: false }).format(until);
  const tomorrow = new Date(now.getTime() + 24 * 3600 * 1000);
  if (dayKey(until) === dayKey(now)) return `ساعت ${time} امروز`;
  if (dayKey(until) === dayKey(tomorrow)) return `ساعت ${time} فردا`;
  return new Intl.DateTimeFormat('fa-IR-u-ca-persian', { timeZone: TZ, year: 'numeric', day: 'numeric', month: 'long' }).format(until);
}

export const lockedUntilMessage = (label: string) =>
  `به‌دلیل نقض قوانین ویزیت آنلاین پذیرش۲۴، نوبت‌دهی ویزیت آنلاین شما تا ${label} غیرفعال است.`;
